import { render } from "./ExternalModal.vue?vue&type=template&id=6a8e6b11&scoped=true"
import script from "./ExternalModal.vue?vue&type=script&lang=js"
export * from "./ExternalModal.vue?vue&type=script&lang=js"

import "./ExternalModal.vue?vue&type=style&index=0&id=6a8e6b11&scoped=true&lang=css"
import "./ExternalModal.vue?vue&type=style&index=1&id=6a8e6b11&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a8e6b11"]])

export default __exports__